const setOlgaMetadata = (features, layerConfig) => {
  return features.map(function(feature) {
    // NOTE: ugly hack to make olga_ metadata available on every feature
    feature.set('olga_', layerConfig)
    return feature
  })
}

export default setOlgaMetadata
